import React from 'react';

/**
 * @func formatDate
 * @desc Returns a formatted string version of a date.
 *
 * @param {Date} date The date to convert.
 * @return {string} The formatted date string.
 */
const formatDate = date => {
  const MONTH = (date.getMonth() + 1).toString();
  const DAY = date.getDate().toString();
  const YEAR = date.getFullYear().toString();
  const HOUR = date.getHours().toString();
  const MINUTES =
    date.getMinutes() < 10 ? `0${date.getMinutes().toString()}` : date.getMinutes().toString();

  return `${MONTH}/${DAY}/${YEAR} ${HOUR}:${MINUTES}`;
};

const DateTableCell = ({ date }) => {
  return <span>{formatDate(date)}</span>;
};

export default DateTableCell;



// WEBPACK FOOTER //
// ./src/components/dispatches/DateTableCell.js